import { ClasslessFilenameTemplateItem } from '../classes/ClasslessFilenameTemplateItem'

export const PhotoSequenceNumber = new ClasslessFilenameTemplateItem({
  id: 'D898C74D-299E-468F-AD9A-1808D667C61B',
  name: 'Photo Sequence Number',
  property: 'photoSequenceNumber',
  help: "A generated sequence number to identify a record's Media Upload",
  exampleValue: '1',
  required: true,
})

export type ClasslessFilename = typeof PhotoSequenceNumber
